import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'
@Injectable()
export class UserDataService {
    private messageDataSource = new BehaviorSubject('None')
    data = this.messageDataSource.asObservable()

    constructor() {}

    sendData(data: string) {
        this.messageDataSource.next(data)
    }
}
